module.exports = __webpack_public_path__ + "img/ic_twitter.597206c8.svg";